import Vue from 'vue'
import VueRouter from 'vue-router'
import ROUTER_MAP from './router-map'
import {
  Modal
} from 'ant-design-vue'
import store from '@/store'
import {
  getQueryString
} from '@/utils/tools'
import login from '@/views/home/login'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalPush1 = VueRouter.prototype.replace
VueRouter.prototype.replace = function push (location) {
  return originalPush1.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import( /* webpackChunkName: "Index" */ '../components/layout/Layout.vue'),
    children: [
      {
      path: '/',
      name: ROUTER_MAP.home,
      // component: () => import( /* webpackChunkName: "Home" */ '../views/home/index.vue'),
      component: () => import( /* webpackChunkName: "Home" */ '../views/home/login.vue'),
    },
      {
        path: '/new_index',
        name: 'new_index',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "new_index" */ '../views/home/new_index.vue'),
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          auth: false,
        },
        component: () => import(/* webpackChunkName: "login" */ '../views/home/login.vue'),
      },
      {
        path: '/word_test',
        name: 'word_test',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "words" */ '../views/word_test/index.vue'),
      },
      {
        path: '/word_competition',
        name: 'word_competition',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "word_competition" */ '../views/word_competition/index.vue'),
      },
      {
        path: '/word_competition_id',
        name: 'word_competition_id',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "word_competition_id" */  '../views/word_competition/id.vue')
      },
      {
        path: '/word_competition_result',
        name: 'word_competition_result',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "word_competition_result" */  '../views/word_competition/result.vue')
      },
      {
        path: '/word_competition_ranking',
        name: 'word_competition_ranking',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "word_competition_ranking" */  '../views/word_competition/ranking.vue')
      },
      {
        path: '/course_video',
        name: 'course_video',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "course_video" */ '../views/course_video/index.vue'),
      },
      {
        path: '/msg',
        name: 'msg',
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "msg" */ '../views/msg/index.vue'),
      },
      {
        path: '/famous_read',
        name: ROUTER_MAP.famous_read,
        meta: {
          auth: true,
        },
        component: () => import(/* webpackChunkName: "famous_read" */ '../views/famous_read/layout.vue'),
        children: [
          {
            path: '/',
            name: 'famous_read_index',
            meta: {
              auth: true,
            },
            component: () => import(/* webpackChunkName: "famous_read" */  '../views/famous_read/index.vue')
          },
          {
            path: 'book',
            name: 'famous_read_book',
            meta: {
              auth: true,
            },
            component: () => import(/* webpackChunkName: "famous_read_book" */ '../views/famous_read/book.vue')
          },
          {
            path: 'detail',
            name: 'famous_read_detail',
            meta: {
              auth: true,
            },
            component: () => import(/* webpackChunkName: "famous_read_detail" */'../views/famous_read/detail.vue')
          },
          {
            path: 'levels',
            name: 'famous_read_levels',
            meta: {
              auth: true,
            },
            component: () => import(/* webpackChunkName: "famous_read_levels" */ '../views/famous_read/levels.vue')
          },
        ]
      },
      // {
      //   path: '/course-center',
      //   meta: {
      //     auth: false,
      //   },
      //   name: ROUTER_MAP.courseCenter,
      //   component: () => import( /* webpackChunkName: "CourseCenter" */ '../views/course-center/index.vue'),
      // },
      // {
      //   path: '/courseDetail',
      //   meta: {
      //     auth: false,
      //   },
      //   name: ROUTER_MAP.courseDetail,
      //   component: () => import( /* webpackChunkName: "CourseCenter" */ '../views/course-center/courseDetail.vue'),
      // },
      // {
      //   path: '/person-center',
      //   meta: {
      //     auth: true,
      //   },
      //   name: ROUTER_MAP.personCenter,
      //   component: () => import( /* webpackChunkName: "CourseCenter" */ '../views/person-center/index.vue'),
      //   children: [
      //     {
      //       path: '/',
      //       name: 'person',
      //       component: () => import ('../views/person-center/person.vue')
      //     },
      //     {
      //       path: 'personInfo',
      //       name: 'personInfo',
      //       component: () => import ('../views/person-center/person.vue')
      //     },
      //     {
      //       path: 'course',
      //       name: 'course',
      //       component: () => import ('../views/person-center/course.vue')
      //     },
      //     {
      //       path: 'study',
      //       name: 'study',
      //       component: () => import ('../views/person-center/study.vue')
      //     },
      //     {
      //       path: 'myWork',
      //       name: 'myWork',
      //       component: () => import ('../views/person-center/myWork.vue')
      //     },
      //     {
      //       path: 'myOrder',
      //       name: 'myOrder',
      //       component: () => import ('../views/person-center/myOrder.vue')
      //     },
      //     {
      //       path: 'myMessage',
      //       name: 'myMessage',
      //       component: () => import ('../views/person-center/myMessage.vue')
      //     }
      //   ]
      // },
      {
        path: '/mycourse',
        name: ROUTER_MAP.myCourse,
        meta: {
          auth: true,
        },
        component: () => import( /* webpackChunkName: "myCourse" */ '../views/mycourse/index.vue'),
      },
      {
        path: '/mycourse_v1',
        name: ROUTER_MAP.myCourse_v1,
        meta: {
          auth: true,
        },
        component: () => import( /* webpackChunkName: "myCourse" */ '../views/mycourse/index_v1.vue'),
      },
      // {
      //   path: '/register',
      //   name: ROUTER_MAP.register,
      //   component: () => import( /* webpackChunkName: "register" */ '../views/register/index.vue'),
      // },
      // {
      //   path: '/teacher-login',
      //   name: ROUTER_MAP.teacherLogin,
      //   component: () => import( /* webpackChunkName: "teacherLogin" */ '../views/teacher-login/index.vue')
      // }
    ]
  },
]
const router = new VueRouter({
  mode: 'hash',
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  Modal.destroyAll()
  if (to.meta.auth) {
    if (store.state.access_token || getQueryString('access_token')) {
      next()
    } else {
      next('/login?redirect=1')
      // store.commit(mTypes.loginModal, true)
    }
  } else {
    //无需登录
    // store.commit(mTypes.loginModal, false)
    next()
  }
})

export default router